// Plain-English meaning for the OFAC program codes that show up most.
const PROGRAMS = {
    SDGT: 'global terrorists',
    SDNTK: 'narcotics traffickers',
    SDNT: 'narcotics traffickers',
    TCO: 'transnational criminal organizations',
    'ILLICIT-DRUGS-EO14059': 'illicit drug trade',
    FTO: 'foreign terrorist organizations',
    NPWMD: 'weapons of mass destruction proliferators',
    IRAN: 'Iran sanctions',
    IRGC: "Iran's Revolutionary Guard",
    IFSR: 'Iran financial sanctions',
    SYRIA: 'Syria sanctions',
    CUBA: 'Cuba sanctions',
    GLOMAG: 'human rights abuse and corruption',
    CYBER2: 'malicious cyber activity',
    'RUSSIA-EO14024': 'Russia sanctions',
    'BELARUS-EO14038': 'Belarus sanctions',
    IRAQ2: 'Iraq sanctions',
}
export const programMeaning = (code) => {
    if (PROGRAMS[code]) return PROGRAMS[code]
    if (/^DPRK/.test(code)) return 'North Korea sanctions'
    if (/^VENEZUELA/.test(code)) return 'Venezuela sanctions'
    if (/^UKRAINE/.test(code)) return 'Russia and Ukraine sanctions'
    return null
}
